export var RuleType;
(function (RuleType) {
    RuleType["DOCUMENT"] = "DOCUMENT";
    RuleType["SEGMENT"] = "SEGMENT";
})(RuleType || (RuleType = {}));
//# sourceMappingURL=rules.js.map